import * as React from "react";

const SnackContext = React.createContext({ snack: '', setSnackMessage: () => {} });

export default SnackContext;